import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="panel-surface flex flex-col items-start gap-4 p-8 text-left">
      <span className="rounded-full border border-gold/25 bg-gold/10 px-4 py-1 text-xs uppercase tracking-[0.24em] text-gold">
        Vazio por enquanto
      </span>
      <div className="space-y-2">
        <h2 className="text-2xl">{title}</h2>
        <p className="max-w-xl text-sm leading-7 text-mist">{description}</p>
      </div>
      {action}
    </div>
  );
}
